import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import { VehicleOption } from '@autos/entities/vehicle';
import { VehicleDetailPayload } from '@autos/entities/vehicle-detail.payload';
import { VehicleDetailResponse } from '@autos/entities/vehicle-detail.response';
import { VehicleResultsPayload } from '@autos/entities/vehicle-results.payload';

export const fetchAutoDetailAction = createAction(type('[Autos/API] Fetch auto detail'),
  props<{ payload: VehicleDetailPayload }>());
export const fetchAutoDetailSuccessAction = createAction(type('[Autos/API] Fetch auto detail success'),
  props<{ payload: VehicleDetailResponse }>());
export const resetAutoDetailAction = createAction(type('[Autos/API] Reset auto detail'));
export const fetchAutoDetailSearchedAction = createAction(type('[Autos/DATA] Fetch auto detail searched'),
  props<{ auto: VehicleOption }>());
export const fetchAutoDetailErrorAction = createAction(type('[Autos/DATA] Auto Details error'),
  props<{ payload: HttpErrorResponse }>());
export const searchAutoAgenciesErrorAction = createAction(type('[Autos/DATA] Auto agencies error'),
  props<{ payload: HttpErrorResponse }>());
export const fetchAutoAgenciesAction = createAction(type('[Autos/API] Fetch autos agencies'),
  props<{ payload: VehicleResultsPayload }>());
export const fetchAutoAgenciesSuccessAction = createAction(type('[Autos/API] Fetch autos agencies success'),
  props<{ autos: VehicleOption[] }>());
export const clearAutoAgenciesAction = createAction(type('[Autos/DATA] Clear auto agencies results'));
